<template>
	<li class="c-site-header__nav-item">
		<slot name="default" v-if="!$slots.dropdown">
			<!-- Fallback content is rendered here -->
		</slot>

		<button
			class="c-site-header__nav-label"
			type="button"
			@click.prevent="() => toggle()"
			:aria-expanded="isOpen"
			:aria-controls="id"
			v-if="$slots.trigger"
		>
			<slot name="trigger"></slot>
		</button>

		<div
			:class="{ 'c-site-header__mega-nav': true, 'is-open': this.isOpen }"
			:id="id"
			v-if="$slots.dropdown"
		>
			<slot name="dropdown"></slot>
		</div>
	</li>
</template>

<script>
	export default {
		name: "mega-menu-item",

		data() {
			return {
				isOpen: false,
			};
		},

		props: {
			id: {
				type: String,
			},
		},

		methods: {
			toggle(open = !this.isOpen) {
				this.isOpen = open;

				if (this.isOpen) {
					document.addEventListener("click", this.handleDocumentClick);
					document.addEventListener("keyup", this.handleDocumentKeyup);
					document.addEventListener("focus", this.handleDocumentFocus, true);
				} else {
					document.removeEventListener("click", this.handleDocumentClick);
					document.removeEventListener("keyup", this.handleDocumentKeyup);
					document.removeEventListener("focus", this.handleDocumentFocus, true);
				}
			},

			/**
			 * @param {KeyboardEvent} event
			 */
			handleDocumentKeyup(event) {
				if (event.key === "Escape") {
					this.toggle(false);
				}
			},

			/**
			 * @param {FocusEvent} event
			 */
			handleDocumentFocus(event) {
				if (this.isOpen && !this.$el.contains(event.target)) {
					this.toggle(false);
				}
			},

			/**
			 * @param {MouseEvent} event
			 */
			handleDocumentClick(event) {
				if (this.isOpen && !this.$el.contains(event.target)) {
					this.toggle(false);
				}
			},
		},
	};
</script>
